import React from 'react'
import { H2 } from '@blueprintjs/core'
import SequenceResume from './SequenceResume.js'

const SequenceGraphs = ({ sequence, results }) => {

    return (
        <div>
            <H2 className='text-center margin-bottom-large margin-top-large new-results'>Ordre de préférence des participants: <br /> {sequence.sequenceContext.toUpperCase()}</H2>
            <div className="row">
                {results.map((res, i) => (
                    <SequenceResume
                        key={i}
                        rank={i + 1}
                        result={res}
                    />
                ))}
            </div>
            <hr className='margin-top-large' />
        </div>
    )
}

export default SequenceGraphs
